import React, { useState } from 'react';
import { PricingCard } from './PricingCard';
import Checkout from '../Popups/Checkout';
import { Grid } from '@/Components/ui/layout';
import {
  Dialog,
  DialogContent,
} from '@/Components/ui/dialog';

export const PricingCards = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showCheckout, setShowCheckout] = useState(false);

  const plans = [
    {
      title: "BASIC",
      price: "0",
      features: [
        "Post 1 Job",
        "Access & Saved 3 Candidates",
        "10 Days Resume Visibility",
        "E-mail Support"
      ],
      isRecommended: false
    },
    {
      title: "STANDARD",
      price: "39",
      features: [
        "3 Active Jobs",
        "Premium Listing",
        "Urgents & Featured Jobs",
        "Highlights Job with Colors",
        "Access & Saved 50 Candidates",
        "1 Month Resume Visibility",
        "E-mail & Call Support"
      ],
      isRecommended: true
    },
    {
      title: "CUSTOM",
      price: "59",
      features: [
        "6 Active Jobs",
        "Urgents & Featured Jobs",
        "Highlights Job with Colors",
        "Access & Saved 100 Candidates",
        "1 Year Resume Visibility",
        "Support"
      ],
      isRecommended: false
    }
  ];

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
    setShowCheckout(true);
  };

  const closeCheckout = () => {
    setShowCheckout(false);
  };

  return (
    <>
      <Grid cols={3} gap="md" justify="center" wrap className="gap-6 mt-10">
        {plans.map((plan, index) => (
          <div key={index} onClick={() => handlePlanSelect(plan)} className="cursor-pointer">
            <PricingCard {...plan} />
          </div>
        ))}
      </Grid>
      <Dialog open={showCheckout} onOpenChange={setShowCheckout}>
        <DialogContent className="max-w-[800px] max-h-[90vh] overflow-y-auto p-5">
          <Checkout plan={selectedPlan} onClose={closeCheckout} />
        </DialogContent>
      </Dialog>
    </>
  );
};
